/* 
  IntersectionObserverで要素を監視
  スクロールに合わせて動きを追加する
---------------------------------------------- */
export const OBSERVER = {
  init: function () {
    // observe_item 用の監視対象
    const observeItemTargets = document.querySelectorAll('.observe_item')
    // observe_item2 用の監視対象
    const observeItem2Targets = document.querySelectorAll('.observe_item2')

    // observe_item 用の関数とオプション
    const setItemActive = entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-fade-up')
        }
      })
    }
    const options1 = {
      root: null,
      rootMargin: '100px 0px',
      threshold: 0.3,
    }
    const observer1 = new IntersectionObserver(setItemActive, options1)

    // observe_item2 用の関数とオプション
    const setItem2Active = entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-fade-in')
        }
      })
    }
    const options2 = {
      root: null,
      rootMargin: '50px 0px', // 異なるオプション例
      threshold: 0.8,
    }
    const observer2 = new IntersectionObserver(setItem2Active, options2)

    // 各監視対象を監視
    observeItemTargets.forEach(target => {
      observer1.observe(target)
    })
    observeItem2Targets.forEach(target => {
      observer2.observe(target)
    })
  },
}
